import React from 'react'

export const HTMLTable = ({itemType}) => {
  const elements = {
    Buttons: ['button', "input[type='submit']"],
    Checkboxes: ['React Component'],
    RadioButtons: ['React Component'],
    Inputs: ["input[type='text']", "input[type='email']", "input[type='password']", "input[type='number']", "textarea"],
    Labels: ['label'],
    Typography: ['h1', 'h2', 'h3', 'p', 'li', 'a'],
    Colors: [],
    Icons: ['span'],
    Dropdown: []
  }

  const classes = {
    Buttons: ['.button', '.primary', '.secondary', '.tertiary', '.warning', '.warning-hollow', '.sm', '.lg'],
    Checkboxes: ['.sm', '.md', '.lg'],
    RadioButtons: ['radio-button-container'],
    Inputs: ['.input', '.textarea'],
    Labels: ['.label'],
    Typography: [],
    Colors: [],
    Icons: ['bff-[icon name here]'],
    Dropdown: ['.dropdown-item', '.dropdown-container', '.dropdown-parent']
  }

  const createHtmlCodeElements = () => {
    if (elements[itemType].length == 0) {
      return <h4 className='empty-col'>{`none`}</h4>
    } else {
      return elements[itemType].map( (el, i) => {
        return <code key={ i }>{el}</code>
      })
    }
  }

  const createHtmlCodeClasses = () => {
    if (classes[itemType].length == 0) {
      return <h4 className='empty-col'>{`none`}</h4>
    } else {
      return classes[itemType].map( (el, i) => {
        return <code key={ i }>{el}</code>
      })
    }
  }

  return (
    <div className='html-table'>
      <div className='table-row'>
        <div className='table-title'><h4>Elements</h4></div>
        <div className='table-col'>
          { createHtmlCodeElements() }
        </div>
      </div>
      <div className='table-row'>
        <div className='table-title'><h4>Classes</h4></div>
        <div className='table-col'>
          { createHtmlCodeClasses() }
        </div>
      </div>
    </div>
  )
}
